import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { BodyWrapper, Header, MainWrapper, MenuForm } from '@components';
import { GlobalContext } from '@contexts';
import { businessQuery, linklistMutation, siteQuery } from '@queries';
import { ChevronRightIcon } from '@svgs';

import { TemplateSidebar } from '../components/TemplateSidebar/TemplateSidebar.jsx';

export const AddMenu = () => {
  const { t, i18n } = useTranslation();
  const { businessID, siteID } = useParams();
  const navigate = useNavigate();
  const globals = useContext(GlobalContext);
  const queryClient = useQueryClient();
  // get business
  const { data: businessData, isPending: businessIsPending } = useQuery(
    businessQuery(businessID),
  );

  // get site/template
  const { data: siteData, isPending: siteIsPending } = useQuery(
    siteQuery(siteID),
  );

  // save datamodel
  const mutation = useMutation(
    linklistMutation(null, {
      onSuccess: (data) => {
        // invalidate the linklists list so it is fetched again
        queryClient.invalidateQueries({ queryKey: ['linklists', 'list'] });
        // navigate to the edit view
        navigate(
          `/dashboard/projects/${businessID}/templates/${siteID}/menus/${data.id}`,
        );
      },
    }),
  );

  return (
    <>
      <Header />
      <BodyWrapper>
        <TemplateSidebar
          businessID={businessID}
          businessData={businessData}
          siteID={siteID}
          siteData={siteData}
        />
        <MainWrapper>
          <div className="sb-main-breadcrumbs">
            <ul className="sb-flex">
              {globals.visible.projectsView && (
                <li className="sb-flex">
                  <Link to={`/dashboard/projects`}>Projects</Link>
                  <ChevronRightIcon />
                </li>
              )}
              <li className="sb-flex">
                {businessIsPending && <span>...</span>}
                {!businessIsPending && (
                  <Link to={`/dashboard/projects/${businessData.id}`}>
                    {businessData.business_name}
                  </Link>
                )}
                <ChevronRightIcon />
              </li>
              <li className="sb-flex">
                <Link to={`/dashboard/projects/${businessID}/templates`}>
                  Templates
                </Link>
                <ChevronRightIcon />
              </li>
              <li className="sb-flex">
                <Link
                  to={`/dashboard/projects/${businessID}/templates/${siteID}`}
                >
                  {siteIsPending && <>...</>}
                  {!siteIsPending && <>{siteData.title}</>}
                </Link>
                <ChevronRightIcon />
              </li>
              <li className="sb-flex">
                <Link
                  to={`/dashboard/projects/${businessID}/templates/${siteID}/menus`}
                >
                  Menus
                </Link>
                <ChevronRightIcon />
              </li>
              <li className="sb-flex">
                <span>Add</span>
              </li>
            </ul>
          </div>
          <div className="sb-manage-content">
            <div className="sb-manage-content-head">
              <h1>{t('Add')}</h1>
            </div>
            <MenuForm
              disabled={mutation.isPending}
              mutation={mutation}
              onCancel={() => {
                navigate(
                  `/dashboard/projects/${businessID}/templates/${siteID}/menus`,
                );
              }}
              siteID={siteID}
            />
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};
